import { Navigate, Outlet } from 'react-router-dom';
import { Layout } from 'webReservations/layout/Layout';
import { useOfferCheckoutContext } from '../context/OfferCheckoutContext';
import { useUserContext } from '../context/UserContext';
import { LANDING_PATH } from '../paths';
import styles from './OfferCheckoutLayout.scss';

export const OfferCheckoutLayout = () => {
  const { isAuthenticated } = useUserContext();
  const { offerCheckout } = useOfferCheckoutContext();

  if (!isAuthenticated || !offerCheckout) {
    return <Navigate to={LANDING_PATH} />;
  }

  return (
    <Layout className={styles.layout}>
      <Outlet />
    </Layout>
  );
};
